import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styles from "components/settings/integration-settings.scss";
import { trackPageAction } from "actions/shared/tracking-actions";
import { SettingsInlineTabs } from "components/settings/settings-inline-tabs";

class IntegrationsPage extends React.Component {
  componentWillMount() {
    this.props.init(this.props.accountId);
    this.props.trackPage();
  }

  render() {
    const iframeParams = "&showHeader=false&reauthorise=true&parent=digit";
    return (
      <div className={ styles.container }>
        <SettingsInlineTabs currentPage={ "integration" } slug={ this.props.accountId } />
        <div className={ styles["iframe-container"] }>
          <iframe
            className={ styles.iframe }
            src={ `${INTEGRATIONS_PAGE_BASE_URL}accountid=${this.props.accountId}${iframeParams}` }
          />
        </div>
      </div>
    );
  }
}

IntegrationsPage.propTypes = {
  accountId: PropTypes.string.isRequired,
  init: PropTypes.func.isRequired,
  trackPage: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  accountId: state.app.selectedAccount.id
});

const mapDispatchToProps = (dispatch) => ({
  init: () => null,
  trackPage: () => dispatch(trackPageAction("Integration settings page"))
});

export const IntegrationSettingsContainer = connect(mapStateToProps, mapDispatchToProps)(IntegrationsPage);



// WEBPACK FOOTER //
// ./src/js/containers/settings/integration-settings-container.jsx